import React, { useState } from 'react';
import axios from 'axios';
import '../styles/SellerProductForm.css';

const SellerProductForm = ({ onProductAdded, onCancel }) => {
  const [formData, setFormData] = useState({
    prod_code: '',
    prod_name: '',
    prod_description: '',
    prod_price: '',
    prod_stock: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!formData.prod_name || !formData.prod_price) {
      setError('El nombre y el precio son obligatorios');
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError('No se encontró token de autenticación');
        return;
      }
      
      const response = await axios.post('/api/products/seller', formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      if (response.status === 201) {
        // Limpiar formulario
        setFormData({
          prod_code: '',
          prod_name: '',
          prod_description: '',
          prod_price: '',
          prod_stock: ''
        });
        
        // Notificar al componente padre
        if (onProductAdded) {
          onProductAdded(response.data);
        }
      }
    } catch (error) {
      console.error('Error al registrar producto:', error);
      setError(error.response?.data?.message || 'Error al registrar el producto');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="seller-product-form-container">
      <h2>Registrar Nuevo Producto</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit} className="seller-product-form">
        <div className="form-group">
          <label htmlFor="prod_code">Código de Barras (opcional)</label>
          <input
            type="text"
            id="prod_code"
            name="prod_code"
            value={formData.prod_code}
            onChange={handleChange}
            placeholder="Código de barras"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="prod_name">Nombre del Producto *</label>
          <input
            type="text"
            id="prod_name"
            name="prod_name"
            value={formData.prod_name}
            onChange={handleChange}
            placeholder="Nombre del producto"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="prod_description">Descripción</label>
          <textarea
            id="prod_description"
            name="prod_description"
            value={formData.prod_description}
            onChange={handleChange}
            placeholder="Descripción del producto"
            rows="3"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="prod_price">Precio *</label>
          <input
            type="number"
            id="prod_price"
            name="prod_price"
            value={formData.prod_price}
            onChange={handleChange}
            placeholder="Precio"
            step="0.01"
            min="0"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="prod_stock">Stock Inicial</label>
          <input
            type="number"
            id="prod_stock"
            name="prod_stock"
            value={formData.prod_stock}
            onChange={handleChange}
            placeholder="Stock inicial"
            min="0"
          />
        </div>
        
        <div className="form-actions">
          <button type="button" onClick={onCancel} className="cancel-btn">
            Cancelar
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Registrando...' : 'Registrar Producto'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SellerProductForm;
